import "./Loader.scss";

const Loader = ({ text }) => {
  return (
    <div className="app-loader">
      <div className="app-loader__dots">
        <div className="app-loader__dot" />
        <div className="app-loader__dot" />
        <div className="app-loader__dot" />
      </div>
      {text && <div className="app-loader__text">{text}</div>}
    </div>
  );
};

export default Loader;
